<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">Device alerts <strong>{{ this.device.name }}</strong></h4>
              <p class="card-category"></p>
            </template>
            <l-table-params :columns="tableData.columns"
                            :data="tableData.data"
                            :map-name="tableData.mapName"
                            :map-value="tableData.mapValue"
                            class="table-hover table-striped">
            </l-table-params>
          </card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

  import LTableParams from 'src/components/TableParams.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Datepicker from 'vuejs-datepicker';
  import {encodeData} from "../../tools/UrlTools";
  import EventBus from "../../event-bus";

  const Vue = window.Vue;

  const tableColumns = ['Date time', 'Sabotage Main', 'Sabotage Power'];
  const tableData = [{}];
  const tableMapName = {
    'Date time': 'alarmDateTime',
    'Sabotage Main': 'sabotageMain',
    'Sabotage Power': 'sabotagePower',
  };
  const tableMapValue = {

  };

  export default {
    name: "DeviceAlertsPage",
    components: {
      LTableParams,
      Card,
      Datepicker
    },
    data() {
      return {
        device: null,
        tableData: {
          columns: [...tableColumns],
          data: [...tableData],
          mapName: {...tableMapName},
          mapValue: {...tableMapValue},
        },
      }
    },
    mounted() {
      this.loadDevice();
    },

    methods: {
      loadDevice() {
        let url = 'device/' + this.$route.params.deviceId;

        if (this.$route.params.localizationHistoryId !== undefined) {
          url += '?localizationHistoryId=' + this.$route.params.localizationHistoryId;
        }

        this.$http.get(url)
          .then(result => {
            this.device = result.data;

            EventBus.$emit('EVENT_PATHS', [["/#/devices/list", 'Devices'],
              ['/#/devices/details/' + this.$route.params.deviceId, this.device.name],
              ['/#/devices/alerts/' + this.$route.params.deviceId, 'Data']]);

            this.loadAlerts(this.device.serial);
          }, error => {
            console.error(error);
          });
      },
      loadAlerts(serial) {
        let url = 'alarm/' + serial;

        if (this.$route.params.localizationHistoryId !== undefined) {
          url += '/' + this.$route.params.localizationHistoryId;
        }

        let params = {};
        if (this.filterFrom !== null && this.filterFrom) {
          if (typeof this.filterFrom == 'string')
            params['from'] = this.filterFrom;
          else
            params['from'] = this.filterFrom.toISOString().slice(0, 10);
        }
        if (this.filterTo !== null && this.filterTo) {
          if (typeof this.filterTo == 'string')
            params['to'] = this.filterTo;
          else
            params['to'] = this.filterTo.toISOString().slice(0, 10);
        }

        if (Object.keys(params).length)
          url += '?' + encodeData(params);

        this.$http.get(url)
          .then(result => {
            this.tableData.data = result.data;
          }, error => {
            console.error(error);
          });
      },
      filterData() {
        this.loadData(this.device.serial);
      }
    }
  }


</script>
<style>
  .content {
    width: 100%;
    background: #f8f9fa;
  }

  .card-plain {
    margin-bottom: inherit;
  }

  .table-responsive {
    background: whitesmoke;
    border-color: #0e0e0e;
  }

  .card-body {
    background: #f8f9fa;
  }

  .cardPlain {
    margin: 10px;
    margin-top: 20px;
    background-color: #e5e5e5;
  }

  h5 {
    background: #E3E3E3;
  }

  .headStyle {
    background: cadetblue;
  }

  .filterDate {
    margin-bottom: 60px;

  }
</style>
